import { useQuery } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { DisclaimerModalData } from "../types/panel.type";

export const useDisclaimerModalData = (
	rfxId: number | null | undefined,
	evalId: number,
	memberId: number,
	enabled: boolean
) => {
	return useQuery<DisclaimerModalData>({
		queryKey: ["disclaimer-modal", rfxId, evalId, memberId],
		queryFn: () =>
			apiV2
				.get(
					`/rfx/${rfxId}/evaluation/${evalId}/panel-members/${memberId}/disclaimer`
				)
				.then((r) => r.data?.data ?? r.data),
		// TASK-028: never fetch before the RFx id is known — an external panel
		// member's `rfxData` may never resolve, and firing early produced a
		// `/rfx/undefined/...` 404 the moment the modal opened.
		enabled: enabled && !!rfxId,
	});
};
